'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_react@15.6.2@react/react.js
// module id = 1
// module chunks = 0